export default "https://statics.cloudfastin.top/static/v1.27.38.2/store/images/new_codedisplay_0_right.png?a0d3e675f4e66afe97b3be761b60d3b9";